"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.TrackSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('track'),
    layer: zod_1.z.number().optional(),
    start: XYPosition_1.XYPositionSchema,
    end: XYPosition_1.XYPositionSchema,
    center: XYPosition_1.XYPositionSchema.optional(),
    radius: zod_1.z.number().optional(),
    startangle: zod_1.z.number().optional(),
    endangle: zod_1.z.number().optional(),
    width: zod_1.z.number(),
    net: zod_1.z.string().optional(),
});
//# sourceMappingURL=Track.js.map